import React, { Component } from 'react';
import { Input, Select, Icon, Button, Typography } from 'antd';
const { Title, Paragraph, Text } = Typography;

const { Option } = Select;

class Settings2 extends Component {

  state = {
    dataEndPoint: 'jobbary.com/revaliml/links',
  }

  saveUserEndpoints = () => { 
    let endpoints = {
      dataEndPoint: 'https://' + this.state.dataEndPoint,
    }

    this.props.updateSettings(endpoints)
  }

  handleChange = (endPoint, e) => {
    this.setState({
      [endPoint]: e.target.value
    })
  }

  render() {
    return (
      <div>
        <Title>Enter / Edit Endpoints</Title>
        <Paragraph>
          Provide us endpoints that we can call to display your data.
        </Paragraph>
        <br />
        <div>
          <div style={{ marginBottom: 16 }}>
            <p>API Endpoint to Get a List of Data</p>
            <Input addonBefore="https://" value={this.state.dataEndPoint} onChange={(e) => this.handleChange('dataEndPoint', e)}  defaultValue="mysite" />
            <div>
              <p>What should this return to work??</p>
              <p>This should return an array of objects</p>
              <p>With 3 required properties - 1 optional property</p>
              <li>feedback.src (the link to the image)</li>
              <li>feedback.winner (the winning label / prediction)</li>
              <li>feedback.saveUrl (endpoint to save updated data too) </li>
              <br />
              <p> Optional:</p>
              <li>feedback.other (other information you would like displayed next to the image) </li>
            </div>
          </div>
          <br />
        </div>
        <br />
        <Button type="primary" onClick={() => this.saveUserEndpoints()}>Save</Button>
      </div>
    );
  }
}

export default Settings2;